import { customerBaseApi } from "@/react/services/api";

const EXTENSIONS = "EXTENSIONS";
const extensionsUrl = (pbxId) => `pbxes/${pbxId}/extensions`;

export const extensionsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllowedExtensions: build.query({
      query: (pbxId) => ({
        url: `${extensionsUrl(pbxId)}/allowed`,
        method: "GET",
      }),
      providesTags: [EXTENSIONS],
    }),
  }),
});

export const { useGetAllowedExtensionsQuery } = extensionsApi;
